import React from 'react';
import { observer } from 'mobx-react';
import {
  CampaignConfigDto, DiscountDto, PopulatedCampaignUserDtoStatusEnum,
} from '@coretava/api/ecommerce-service';
import TakeSurvey from './TakeSurvey';
import Congrats from './Congrats';

const SurveyCampaign: React.FC<{ campaign: CampaignConfigDto, status: PopulatedCampaignUserDtoStatusEnum, discount?: DiscountDto }> = ({ campaign, status, discount }) => React.useMemo(() => {
  switch (true) {
    case status === PopulatedCampaignUserDtoStatusEnum.Pending:
      return <TakeSurvey campaign={campaign} />;
    case status === PopulatedCampaignUserDtoStatusEnum.Valid && !!discount:
      return <Congrats campaign={campaign} discount={discount} />;
    default:
      return undefined;
  }
}, [status, discount]);

export default observer(SurveyCampaign);
